const coreApi = process.env.REACT_APP_CORE_API + "api/users/v1/";
const coreSSOApi = process.env.REACT_APP_CORE_API + "api/sso/v1/";
const serachApi = process.env.REACT_APP_SEARCH_API + "api/search/v1/";
const analyticApi = process.env.REACT_APP_SEARCH_API + "api/analytic/";
const postApi = process.env.REACT_APP_CORE_API + "api/control-panel/v1/";
const adsApi = process.env.REACT_APP_CORE_API + "api/ads/v1/";
const videosApi = process.env.REACT_APP_CORE_API + "api/videos/v1/";
const utmDecodeApi =
  process.env.REACT_APP_CORE_API + "api/metadata/v1/device/decode-utm";
const reportsV1Api = process.env.REACT_APP_MOM_API + "api/reports/v1/";
const reportsV4Api = process.env.REACT_APP_MOM_API + "api/reports/v4/";
// Const adsApi = "http://localhost:3072/api/ads/v1/";
const groupApi = process.env.REACT_APP_CORE_API + "api/groups/v1/";
// Const groupApi = 'http://localhost:3072/api/groups/v1/admin/';
const productApi = process.env.REACT_APP_CORE_API + "api/products/v1/";
const feedApi = process.env.REACT_APP_CORE_API + "api/content/v1/";
const statsApi = process.env.REACT_APP_EMAIL_API;
// Const allDataApi = process.env.REACT_APP_SEARCH_API + "api/analytic/";
const momApi = process.env.REACT_APP_MOM_API;
const buzzFeedApi = process.env.REACT_APP_CORE_API + "api/buzz-feed/";
const connectionApi = process.env.REACT_APP_CORE_API + "api/connections/v1/";
const connectionFollowApi =
  process.env.REACT_APP_CORE_API + "api/followers/v1/";
const activityApi = process.env.REACT_APP_ACTIVITY_API + "api/v1/";
const internalUserApi =
  process.env.REACT_APP_CORE_API + "api/internalUsers/v1/";
const brandlabsApi = process.env.REACT_APP_BRANDLABS_API;
const authApi = process.env.REACT_APP_CORE_API + "api/";
const gstApi = process.env.REACT_APP_GST_API + "free/gstin/";

const apiUrl = {
  loginUrl: coreApi + "login",
  loginSSOUrl: coreSSOApi + "login",
  registerUrl: coreApi + "add-user",
  verifyEmailUrl: coreApi + "verify-email",
  profileUrl: coreApi,
  otherUsersProfile: coreApi + "profile",
  deleteUserUrl: coreApi + "delete-user",
  updateUserUrl: coreApi,
  updatePassword: coreApi + "change-password",
  searchUrl: serachApi + "query",
  postUrl: postApi + "feed-posts",
  postByUserIdUrl: postApi + "user-posts",
  postByGroupIdUrl: postApi + "group-posts",
  postByPostIdUrl: postApi + "post",
  commentUrl: postApi + "post-comments",
  groupUrl: groupApi + "admin/groups",
  groupMembersUrl: groupApi + "group-members",
  updateGroupUrl: groupApi + "group",
  groupTagsUrl: groupApi + "tags",
  groupByIdUrl: groupApi + "admin/group",
  analyticUrl: analyticApi + "data",
  productsUrl: productApi + "categories",
  productUrl: String(productApi),
  feedUrl: String(feedApi),
  feedWeeksUrl: feedApi + "feed-weeks",
  deletePostUrl: feedApi + "post",
  analyticCountUrl: analyticApi + "count",
  emailUrl: process.env.REACT_APP_EMAIL_API + "bulk-mail",
  sendEmailUrl: process.env.REACT_APP_EMAIL_API + "send-mail",
  notificationUrl:
    process.env.REACT_APP_CORE_API + "api/notifications/v1/send-notification",
  sendNotificationUrl:
    process.env.REACT_APP_NOTIFICATIONS_API + "api/v1/fcm/add-notification",
  emailStatsUrl: statsApi + "getMailerDataByCategory",
  emailStatsByWeekUrl: statsApi + "dataPerWeek",
  userStatsUrl: statsApi + "getUserStats",
  groupCreateUrl: process.env.REACT_APP_CORE_API + "api/groups/v1/group/",
  adsUrl: adsApi + "ad",
  getAdsUrl: adsApi + "ads",
  getTopArticlesUrl: statsApi + "getArticleDetails",
  getavgSessionDurationUrl: statsApi + "getavgSessionDuration",
  sponsoredPost:
    process.env.REACT_APP_BRANDLABS_API + "admin/api/sponsored-posts",
  sponsoredPostById:
    process.env.REACT_APP_BRANDLABS_API + "admin/api/sponsored-post",
  ticketById: process.env.REACT_APP_BRANDLABS_API + "admin/api/ticket/",
  fileDetailsById:
    process.env.REACT_APP_BRANDLABS_API + "admin/api/file-details/",
  putSponsoredPostUrl:
    process.env.REACT_APP_BRANDLABS_API + "admin/api/sponsored-post",
  ticketUrl: process.env.REACT_APP_BRANDLABS_API + "admin/api/ticket",
  sendMessageUrl:
    process.env.REACT_APP_BRANDLABS_API + "admin/api/send-message",
  transactionByIdUrl:
    process.env.REACT_APP_BRANDLABS_API + "admin/api/transaction?productId=",
  applyCouponUrl:
    process.env.REACT_APP_BRANDLABS_API + "admin/api/validate-coupon",
  paymentUpdateUrl:
    process.env.REACT_APP_BRANDLABS_API + "admin/api/payment-status",
  emaiAddsPostUrl: process.env.REACT_APP_BRANDLABS_API + "admin/api/email-adds",
  emaiAdsByIdUrl: process.env.REACT_APP_BRANDLABS_API + "admin/api/email-add",
  couponUrl: process.env.REACT_APP_BRANDLABS_API + "admin/api/coupons/",
  createCouponUrl:
    process.env.REACT_APP_BRANDLABS_API + "admin/api/create-coupon/",
  deleteCouponUrl: process.env.REACT_APP_BRANDLABS_API + "admin/api/coupon/",
  mediaUrl: process.env.REACT_APP_MEDIA_API + "api/media/",
  // campaignUrl: momApi,
  // ExpertsApi:'http://localhost:3072/api/experts/v1/',
  expertsApi: process.env.REACT_APP_CORE_API + "api/experts/v1/",
  notificationStatsUrl: statsApi + "notification/getSendLabel",
  allCityUrl: analyticApi + "countbycity",
  allPincodeUrl: analyticApi + "countbypincode",
  connectionCountUrl: analyticApi + "getConnectionCount",
  notificationLabelUrl: statsApi + "notification/getNotificationLabels",
  notificationLabelOfUrl: statsApi + "notification/getNotificationsOfLabels",
  utmUrl: reportsV1Api + "utm",
  sessionUrl: reportsV1Api + "session",
  createInternalUserUrl: internalUserApi + "internal-users",
  createdByUserDetail: internalUserApi + "created-by",
  impersonateUserUrl:
    process.env.REACT_APP_CORE_API + "api/internalUsers/v1/impersonate",
  notificationLabelStatsUrl:
    statsApi + "notification/getUserDataAccordingToDay",
  utmDecodeUrl: utmDecodeApi,
  quizUrl: buzzFeedApi + "quiz",
  quizUsersUrl: buzzFeedApi + "users",
  getAllQuizUrl: buzzFeedApi + "quizs",
  quizResultUrl: buzzFeedApi + "result",
  quizQuesUrl: buzzFeedApi + "question",
  quizOptionUrl: buzzFeedApi + "option",
  createVideoUrl: videosApi + "video",
  getAllVideoUrl: videosApi + "videos",
  getConnectionDataUrl: connectionApi + "connection-history",
  getNumberOfFollowUrl: connectionFollowApi + "no-of-follow",
  getNumberOfUserSendingFollowUrl:
    connectionFollowApi + "no-of-users-sending-follow",
  getNumberOfFollowUsersUrl: connectionFollowApi + "no-of-users",
  getActivityLogsUrl: activityApi + "activity-logs",
  getAllBrandsUrl: brandlabsApi + "admin/api/onboarding/",
  getSingleBrandUrl: brandlabsApi + "api/onboarding/",
  getAllCreatives: brandlabsApi + "api/creative/",
  fileDetailsApi: brandlabsApi + "api/file-details/",
  sponsoredPostUrl: brandlabsApi + "api/sponsored-post",
  onBoardingUrl: brandlabsApi + "api/onboarding/",
  phoneOtpUrl: authApi + "users/",
  campaignUrl: brandlabsApi + "api/campaign/",
  paypalOrderApi: brandlabsApi + "api/order-paypal",
  paypalCaptureApi: brandlabsApi + "api/capture-paypal",
  razorPayOrderApi: brandlabsApi + "api/order/",
  razorPayCaptureApi: brandlabsApi + "api/capture/",
  leadGenApi: brandlabsApi + "api/leadgen/",
  getLedgerUrl: brandlabsApi + "api/ledger/",
  getTransactionsUrl: brandlabsApi + "api/transaction/",
  internalLogin: process.env.REACT_APP_CORE_API + "api/internalUsers/v1/token",
  getGstDataUrl: gstApi,
  transactionApi: brandlabsApi + "transaction?",
  campaignReportsUrl: reportsV4Api,
};

export default apiUrl;
